import { render, staticRenderFns } from "./ChatV2.vue?vue&type=template&id=fdc06ec8"
import script from "./ChatV2.vue?vue&type=script&lang=js"
export * from "./ChatV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports